import vuei18n from '@/plugins/vuei18n'
import store from '@/store/store'

export default class FileValidator {
  constructor(config){
    this.config = { ...{
      maxSize : 1024,
      allowedExtension : ["png","jpg","jpeg","jpe"],
      allowedType : ["image/png", "image/jpeg"]
    }, ...config }
  }

  validate(file){
    if(file.size/1024 > this.getMaxSize()){ //KB
      this.showErrorMessage(vuei18n.t('schema.builder.inputs.description.max_size'))
      return false;
    }
    if (file.name.lastIndexOf('.') <= 0){
        this.showErrorMessage(vuei18n.t('schema.builder.inputs.description.bad_filename'))
        return false
      }
    if (!this.getAllowedTypes().includes(file.type) && !this.getAllowedExtensions().includes(file.name.split('.').pop())){
        this.showErrorMessage(vuei18n.t('schema.builder.inputs.description.bad_extension'))
        return false
      }
    return true
  }

  getAllowedExtensions(){
    return this.config.allowedExtension
  }

  getAllowedTypes(){
    return this.config.allowedType
  }

  getMaxSize(){
    return this.config.maxSize
  }

  showErrorMessage(msg) {
      store.commit("setSnack", {
        message: msg,
      })
    }

    getPdfValidator(){
      return new FileValidator({
        maxSize : 1024 * 10,
        allowedExtension : ["pdf"],
        allowedType : ["application/pdf"]
      })
    }




}
